import React from 'react';

import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { ACCOUNT_USER_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/accountUserConstants';
import { IAccountUserListViewModel } from './AccountUserListViewModel';
import { ColumnUtilsType } from './types/column';
import columns from './columns';
import {
  LIST_PAGINATION_MODEL,
  ACCOUNT_USER_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_USER_LIST_SORT_OPTION_MODEL,
} from './models/options';

const AccountUserList = (props: IAccountUserListViewModel): JSX.Element => {
  const { list, totalCount, options, gradeList, getList, requestDownloadExcel } = props;
  const { filterOption, sortOption, pagination } = options;

  return (
    <div className="account-user-list-wrap">
      <div className="account-user-list">
        <TableWithSummary
          data={list}
          totalCnt={totalCount}
          initialOption={{
            filterOption: ACCOUNT_USER_LIST_FILTER_OPTION_MODEL,
            sortOption: ACCOUNT_USER_LIST_SORT_OPTION_MODEL,
            pagination: LIST_PAGINATION_MODEL,
          }}
          isStriped={true}
          emptyText={ACCOUNT_USER_LIST_TABLE_EMPTY_TEXT}
          showPagination
          filterOption={filterOption}
          sortOption={sortOption}
          pagination={pagination}
          getList={getList}
          getExcelDownload={requestDownloadExcel}
          columns={(utils: ColumnUtilsType) =>
            columns({
              gradeList,
              ...utils,
            })
          }
        />
      </div>
    </div>
  );
};

export default AccountUserList;
